import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import { ToolIcon, CheckIcon, NamingConventionsIcon } from '@segment/matcha/components/Icons/Brandbook'
import IconWrapper from '@segment/matcha/components/IconWrapper'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const features = [
  {
    heading: `Get the best tools`,
    description: `Integrate new tools in minutes, not weeks. No more setup headaches and no need to push code.`,
    icon: <ToolIcon />,
  },
  {
    heading: `Power your tools with the same data`,
    description: `No more waiting for App Store approval! Turn on new tools instantly, even ones without their own mobile SDK.`,
    icon: <CheckIcon />,
  },
  {
    heading: `Focus on product work, not integration coding`,
    description: `Segment makes trying new tools incredibly easy. No more costly integration processes that prevent you from using the best tools.`,
    icon: <NamingConventionsIcon />,
  },
]

export const Feature = () => {
  return (
    <StyledSectionBase variant="noCopy">
      <Section.Contents>
        <ColumnTrack columns={1} overrides={{ md: 3 }}>
          {features.map((feature) => (
            <StyledFeatureBoxBase key={feature.heading} alignment="left" headerPosition="top">
              <FeatureBox.Header>
                <IconWrapper variant="circle" elevation={1}>
                  {feature.icon}
                </IconWrapper>
              </FeatureBox.Header>
              <FeatureBox.Body>
                <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                <FeatureBox.Text>{feature.description}</FeatureBox.Text>
              </FeatureBox.Body>
            </StyledFeatureBoxBase>
          ))}
        </ColumnTrack>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  max-width: 1290px;
`

const StyledFeatureBoxBase = styled(FeatureBoxBase)`
  padding: 16px;
  max-width: 336px;
  justify-self: center;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    max-width: unset;
  }

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding: 24px;
  }
`

export default Feature
